// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import Button from '@/components/button';
import Fetch from '@/utils/Fetch';
import ManageStore from '@/components/store/manage';
import SettingsMenu from '@/components/settings/menu';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import SubscriptionContext from '@/utils/subscription-context';
import BillingService from '@/services/billing-service';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function StorePage() {

  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const subscriptionContext = useContext(SubscriptionContext);
  const toast = useContext(ToastContext);

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [saving, setSaving] = useState(false);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [canAmendSubscription, setCanAmendSubscription] = useState(false);
  const [disableSave, setDisableSave] = useState(false);

  const getSubcriptionInfo = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
      setCanAmendSubscription(subscriptionInfo.AccessStatus !== Enums.AccessStatus.Trial);
    }
  };

  useEffect(() => {
    getSubcriptionInfo();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveStore);

  const { data: storeData } = useQuery(
    ['store', id],
    () => Fetch.get({ url: `/Store/${id}` }),
    { enabled: !!id }
  );

  const [store, setStore] = useState<any>(null);
  const [isDefaultDisabled, setDefaultDisabled] = useState(false);

  useEffect(() => {
    if (storeData && !store) {
      setStore(storeData);
      setDefaultDisabled(storeData.IsDefault == true);
    }
  }, [storeData]);

  function updateStore(field: any, value: any) {
    let newStoreState = { ...store };
    newStoreState[field] = value;
    setStore(newStoreState);
    setFormIsDirty(true);
  }

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {

    let validationItems = [];
    validationItems = [
      { key: 'Name', value: store.Name, required: true, type: Enums.ControlType.Text },
      { key: 'Code', value: store.Code, required: true, type: Enums.ControlType.Text },
      { key: 'AddressLine1', value: store.AddressLine1, required: true, type: Enums.ControlType.Text },
      { key: 'AddressLine2', value: store.AddressLine2, required: true, type: Enums.ControlType.Text },
      { key: 'AddressLine3', value: store.AddressLine3, required: true, type: Enums.ControlType.Text },
      { key: 'PostalLine1', value: store.PostalLine1, required: true, type: Enums.ControlType.Text },
      { key: 'PostalLine2', value: store.PostalLine2, required: true, type: Enums.ControlType.Text },
      { key: 'PostalLine3', value: store.PostalLine3, required: true, type: Enums.ControlType.Text },
      { key: 'Telephone', value: store.TelephoneNumber, required: true, type: Enums.ControlType.Text },
      { key: 'EmailFromName', value: store.EmailFromName, required: true, type: Enums.ControlType.Text },
      { key: 'EmailFromAddress', value: store.EmailFromAddress, required: true, type: Enums.ControlType.Email },
      { key: 'TaxPercentage', value: store.TaxPercentage, required: true, type: Enums.ControlType.Number },
      { key: 'QuoteExpiry', value: store.QuoteExpiryPeriod, required: true, type: Enums.ControlType.Number },
      { key: 'InvoiceDue', value: store.InvoiceDuePeriod, required: true, type: Enums.ControlType.Number },
    ];

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  };

  const [uploading, setUploading] = useState(false);

  const onUploadLogoChange = (e: any) => {

    let isValid = validate();
    if (isValid) {
      let reader = new FileReader();
      let file = e.target.files[0];
      reader.onloadend = async function () {
        let b64 = (reader.result as any).replace(/^data:.+;base64,/, '');

        let params = { ...store, FileBase64: b64 };
        setUploading(true);
        const storePut = await Fetch.put({
          url: '/Store',
          params: params,
          toastCtx: toast
        });
        setUploading(false);

        if (storePut.ID) {
          toast.setToast!!!({
            message: 'Logo uploaded successfully',
            show: true,
            type: Enums.ToastType.success
          });
          setStore(storePut);
          setFormIsDirty(false);
        }
      };
      reader.readAsDataURL(file);
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });
    }

  };

  async function deleteLogo() {
    //Store/DeleteLogo
    const storePut = await Fetch.put({
      url: `/Store/DeleteLogo?id=${store.ID}`,
      params: {},
      toastCtx: toast
    });

    if (storePut.ID) {
      toast.setToast!!!({
        message: 'Logo deleted successfully',
        show: true,
        type: 'success'
      });
      setStore({ ...store, LogoURL: null, LogoExists: false });
    } else {
      toast.setToast!!!({
        message: storePut.serverMessage,
        show: true,
        type: Enums.ToastType.error
      });
    }
  };

  async function saveStore() {
    setSaving(true);

    let isValid = validate();
    if (isValid) {
      const storePut = await Fetch.put({
        url: '/Store',
        params: store,
        toastCtx: toast
      });

      if (storePut.ID) {
        toast.setToast!!!({
          message: 'Store saved successfully',
          show: true,
          type: 'success'
        });
        setStore(storePut);
        setDefaultDisabled(storePut.IsDefault == true);
        setFormIsDirty(false);
      } else {
        toast.setToast!!!({
          message: storePut.serverMessage,
          show: true,
          type: Enums.ToastType.error
        });
        setDisableSave(false);
      }
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });
    }

    setSaving(false);
    return isValid;
  }

  const cancel = () => {
    Helper.nextRouter(Router.push, '/settings/store/list');
  };

  if (!store) return null;

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '', suppressLink: true },
              { text: 'Stores', link: '/settings/store/list' },
              { text: `${store.Name ? store.Name : 'Edit store'}`, link: '' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <div className="actions">
            <Button disabled={saving || accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || disableSave}
              text={saving ? "Saving" : 'Save'} onClick={saving ? null : saveStore} extraClasses="auto no-margin"
            />
            <Button text="Cancel" extraClasses="auto hollow" onClick={cancel} />
          </div>
          <ManageStore store={store} updateStore={updateStore} inputErrors={inputErrors} defaultDisabled={isDefaultDisabled}
            canAmendSubscription={canAmendSubscription} disableSave={disableSave} setDisableSave={setDisableSave}
            onUploadLogoChange={onUploadLogoChange} deleteLogo={deleteLogo} uploading={uploading} />
        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .row {
          display: flex;
        }
        .actions {
          display: flex;     
          flex-direction: row-reverse;              
        }
        .actions :global(.button){
            margin-left: 0.5rem;
            margin-top: 0;
            padding: 0 1rem;
            white-space: nowrap;
        }
      `}</style>
    </div>
  );
}

export default StorePage;

export const Route = createFileRoute('/_authenticated/settings/store/$id')({ component: StorePage })
